// removed by extract-text-webpack-plugin
module.exports = {"Login":"_3XyDsajapxxeCO_J2Eqy5u","Logo":"_3LkWj7OWRUqDNUQbemA88d","Content":"_3xylHccuL1covE5EPDMdeP","Form":"_2Pv7Jl1le9p9b4gi5yTJzC","Footer":"_122pszWI92_7aZNQfBgG5J _1FL9MexFCBWUtchy9KsrIa"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/styles.css
// module id = 656
// module chunks = 0